import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PrismicErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  state = {
    error: null,
    errorInfo: null,
    isExpanded: false
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    const { error, errorInfo, isExpanded } = this.state;

    if (error && errorInfo) {
      if (CONFIG.isProduction) {
        return null;
      }

      const { componentStack } = errorInfo;
      const [_match, component] =
        componentStack.match(/in\s*([a-zA-Z]*)\s/) || [];
      const [_secondMatch, file] =
        componentStack.match(/\(at\s([a-zA-Z]*\.jsx:[0-9]*)\)/) || [];

      return (
        <div className="PrismicErrorBoundary mb8 mb12-md mb14-lg container">
          <div className="ph4 pv6 bg-yellow">
            {component && (
              <p className="mb4">
                <span className="fw-medium red">{component}</span>
                {file && <span>&nbsp;({file})</span>}
                &nbsp;has an error:
              </p>
            )}
            <p className="mb4 fw-medium">{error.toString()}</p>
            {isExpanded && (
              <p className="mb4 pre-wrap">{componentStack.trim()}</p>
            )}
            <button
              className="ph2 pv2 ba b--black bw1 fw-medium"
              onClick={() => this.setState({ isExpanded: !isExpanded })}
              type="button"
            >
              {isExpanded ? 'Hide stacktrace' : 'Show stacktrace'}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
